import React from 'react';
import PropTypes from 'prop-types';
import { values, result } from 'underscore';
import { CampaignType } from '@bingads-webui-campaign-react/shell-ui-common';
import { QueryParam } from '@bingads-webui-react/scope-service';
import { siteMapPropType } from '@bingads-webui-campaign-react/with-site-map';
import { SummaryBarFactory } from './components';
import { experimentAdGroupEntityItems, showErrorWithAlertCenter } from './helpers';
import { convertToSummaryBarStatusPatch } from './helpers/entity-converter';

export const ExperimentAdGroupSummaryBar = ({
  adGroup,
  i18n,
  scope,
  siteMap,
  updateAdGroup,
  canEdit,
  summaryBarActivityLogger,
  permissions,
  excludedLocationOnly,
}) => {
  const changeStatus = selectedStatus => updateAdGroup({
    adGroup,
    patch: { status: selectedStatus.id },
    converter: convertToSummaryBarStatusPatch,
  }).catch((response) => {
    showErrorWithAlertCenter(response, i18n);
  });

  const updateBid = patch => updateAdGroup({
    adGroup,
    patch,
  });

  const adGroupSummaryBarItems = experimentAdGroupEntityItems({
    changeStatus, scope, siteMap, i18n, ...adGroup, canEdit, updateBid, permissions, summaryBarActivityLogger, excludedLocationOnly,
  });

  const {
    id,
    name,
    campaignType,
    campaignId,
    campaignName,
  } = adGroup;

  const summaryBarProps = {
    breadcrumbsProps: {
      campaignName,
      campaignId,
      campaignType,
      adGroupId: id,
      adGroupName: name,
    },
    summaryBarItems: adGroupSummaryBarItems,
    i18n,
    summaryBarActivityLogger,
    scope,
    siteMap,
  };

  const isAppBarBreadcrumbEnabled = result(permissions.dynamic, 'AppBarBreadcrumb', false);
  return (<SummaryBarFactory {...summaryBarProps} hideBreadcrumb={isAppBarBreadcrumbEnabled} />);
};

ExperimentAdGroupSummaryBar.propTypes = {
  adGroup: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    campaignId: PropTypes.number.isRequired,
    campaignName: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    campaignType: PropTypes.oneOf(values(CampaignType)).isRequired, // campaignType is for breadscrumb
    currentCampaignType: PropTypes.oneOf(values(CampaignType)).isRequired,
    campaignSubType: PropTypes.string,
    bid: PropTypes.number.isRequired,
    displayBiddingStrategyType: PropTypes.string.isRequired,
    bidStrategy: PropTypes.string.isRequired,
    locations: PropTypes.array,
    audiences: PropTypes.array,
    devices: PropTypes.array,
  }).isRequired,
  excludedLocationOnly: PropTypes.bool.isRequired,
  scope: PropTypes.instanceOf(QueryParam).isRequired,
  siteMap: siteMapPropType.isRequired,
  updateAdGroup: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  canEdit: PropTypes.bool.isRequired,
  summaryBarActivityLogger: PropTypes.shape({
    changeScopeActivity: PropTypes.any,
  }).isRequired,
  permissions: PropTypes.shape({}).isRequired,
};
